import { useMutation, useQueryClient } from '@tanstack/react-query';

import { axiosApi } from '@/api/axios';
import { WithdrawBonusesBody, WithdrawBonusesResponse } from '@/api/types';
import { useAuthStore } from '@/store';

export const useWithdrawBonuses = () => {
    const { token } = useAuthStore();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (data: WithdrawBonusesBody) => {
            const { data: resData, status } = await axiosApi.post<WithdrawBonusesResponse>(
                '/bonuses/payout',
                data,
                {
                    headers: { Authorization: `Bearer ${token}` },
                    validateStatus: () => true,
                }
            );

            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ['user', token] });
            }

            if (status >= 400) {
                return {
                    errors: resData.errors,
                    status,
                };
            }
        },
    });
};
